import { Form } from "react-router-dom";
import useFocusOnLoad from "../hooks/useFocusOnLoad";
import { Box, Button, Heading } from "@ogt/ui";
import { useNavigate } from "react-router-dom";

export default function Fail() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const navigate = useNavigate();

  return (
    <div>
      <Form>
        <Box>
          <Heading headingRef={h2Ref} focusable id="SendFailed">
            Ett fel inträffade
          </Heading>
          <p>Något verkar ha gått fel i din ansökan. Testa gärna igen.</p>
          <p>Har du frågor kan du kontakta kundservice.</p>
        </Box>
        <div className="flex justify-center">
          <div className="w-full text-left flex items-center">
            <Button
              iconPosition="left"
              iconSize={16}
              iconName="arrow-left"
              aria-label="Tillbaka"
              showIcon
              size="medium"
              variant="outline"
              onClick={(event) => {
                event.preventDefault();
                const backUrl = undefined;
                if (backUrl) {
                  navigate(backUrl, { replace: true });
                } else {
                  navigate(-1);
                }
              }}
            >
              Tillbaka
            </Button>
          </div>
        </div>
      </Form>
    </div>
  );
}
